import { Link } from "react-router-dom";

const linkStyle = {
  color: "var(--muted)",
  letterSpacing: "0.06em",
  textDecoration: "none",
};

/** Persistent site footer with legal + brand links. */
export default function Footer() {
  return (
    <footer
      className="relative z-10 mt-16 border-t px-6 py-8 text-center text-xs"
      style={{
        borderColor: "rgba(154,151,164,0.14)",
        color: "var(--muted)",
        letterSpacing: "0.08em",
      }}
      data-testid="site-footer"
    >
      <nav
        className="mx-auto flex max-w-xl flex-wrap items-center justify-center gap-x-6 gap-y-2"
        data-testid="footer-line-1"
      >
        <Link to="/philosophers" style={linkStyle} data-testid="footer-philosophers">
          Philosophers
        </Link>
        <span aria-hidden style={{ color: "var(--muted)" }}>·</span>
        <Link to="/blog" style={linkStyle} data-testid="footer-blog">
          Blog
        </Link>
        <span aria-hidden style={{ color: "var(--muted)" }}>·</span>
        <Link to="/terms" style={linkStyle} data-testid="footer-terms">
          Terms
        </Link>
        <span aria-hidden style={{ color: "var(--muted)" }}>·</span>
        <Link to="/privacy" style={linkStyle} data-testid="footer-privacy">
          Privacy
        </Link>
        <span aria-hidden style={{ color: "var(--muted)" }}>·</span>
        <Link to="/refunds" style={linkStyle} data-testid="footer-refunds">
          Refunds
        </Link>
      </nav>
      <p
        className="mt-4"
        style={{ color: "var(--muted)", letterSpacing: "0.08em" }}
        data-testid="footer-line-2"
      >
        Contact ·{" "}
        <a
          href="mailto:contact@thephilosophertest.com"
          style={{ ...linkStyle, textDecoration: "underline", textDecorationColor: "rgba(154,151,164,0.35)", textUnderlineOffset: "3px" }}
          data-testid="footer-contact"
        >
          contact@thephilosophertest.com
        </a>
      </p>
    </footer>
  );
}
